<template>
  <div style="display:inline-block;">
    <label class="radio-label" style="padding-left:0;max-width:26%;letter-spacing:-1px;">{{ $t('excel.filename') }}: </label>
    <el-input v-model="filename" :placeholder="$t('excel.filename_placeholder')" style="width:335px;max-width:73%;" prefix-icon="el-icon-document" />
  </div>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            default: ''
        }
    },
    computed: {
        filename: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        }
    }
};
</script>
